import React, { useEffect, useState } from 'react'
import AreaService from '../api/areaService'

import './tooltip.css'
import Loader1 from './../CommonElements/Spinner/loader'
import { Button, OverlayTrigger, Popover } from 'react-bootstrap'


export default function VerifiedAlertsComponent({filters}) {

    const userID = JSON.parse(localStorage.getItem('userData')).id
    const factoryID = JSON.parse(localStorage.getItem('userData')).factory.id

    const [loader, setloader] = useState(false)

    const [data, setdata] = useState({})

    async function fetchData() {
      const payload ={
        user_id: userID,
        factory_id: factoryID,
        identifier: (filters?.weekly || filters?.week) ? 'week' : filters?.month ? 'month' : 'date',
        filters: {
          module:  filters?.module ? [filters.module] : [],
          shift: filters?.shift ? ( Array.isArray(filters?.shift) ? filters?.shift  :  (filters?.shift ? [filters.shift] : [])) : ( Array.isArray(filters?.shifts) ? filters?.shifts  :  (filters?.shifts ? [filters.shifts] : [])),
          severity: filters?.severity ? filters.severity : '',
          area: filters?.areas ? ( Array.isArray(filters?.areas) ? filters?.areas  :  (filters?.areas ? [filters.areas] : [])) : ( Array.isArray(filters?.area) ? filters?.area  :  (filters?.area ? [filters.area] : [])),
          subarea: Array.isArray(filters?.subarea) ? filters?.subarea  :  (filters?.subarea ? [filters.subarea] : []),
          date: filters?.date ? filters.date : '',
          week: filters?.weekly ? filters.weekly : filters?.week ? filters?.week : '',
          month: filters?.month ? filters.month : '',
          starting: filters?.starting ? filters.starting : '',
            ending: filters?.ending ? filters.ending : '',
        }
      }
      setloader(true)

      const res = await AreaService.getVerifiedAlertsRecords(payload)
      if(res){
        setloader(false)
      }
      setdata({
        totalAlerts: res?.data?.data?.total_alerts,
        totalVerfied: (res?.data?.data?.accepted_techqa + res?.data?.data?.rejected_techqa),
        verifiedViolations: res?.data?.data?.accepted_techqa,
        verifiedNonViolations: res?.data?.data?.rejected_techqa,
      })
    }

    useEffect(() => {
        fetchData();

    }, [filters])
    
  const [tooltipOpen, setTooltipOpen] = useState(false)

    const toggleTooltip = () => setTooltipOpen(!tooltipOpen)

  return (
    <>
   {/* <div  id="verifiedAlertsDiv" className=' d-flex align-items-center justify-content-center gap-2 me-2 px-2' style={{backgroundColor:'#dde8f9', color:'#175fa4', border:'1px solid #175fa4', borderRadius:'8px',  maxWidth:'200px', height:'45px'}}>
    {
        loader ? (
               <div className="spinner-border spinner-border-sm text-primary" role="status"></div>


        ) : (
            <>

<p className='p-0 m-0'>Verified Alerts</p>
<p className='p-0 m-0' style={{fontSize:'20px', fontWeight:'700',color:'#175fa4'}}>{data?.verifiedViolations + data?.verifiedNonViolations}</p>
            </>
        )
    }

   </div>
 <Tooltip
  placement="top"
  isOpen={tooltipOpen}
  target="verifiedAlertsDiv"
  toggle={toggleTooltip}
  className="custom-tooltip"
  innerClassName="custom-tooltip-inner"
>
  <div><strong>Total Alerts:</strong> {data?.totalAlerts}</div>
  <div><strong>Verified Alerts:</strong> {data?.totalVerfied}</div>
  <div><strong>Violations:</strong> {data?.verifiedViolations}</div>
  <div><strong>Non-Violations:</strong> {data?.verifiedNonViolations}</div>
</Tooltip> */}
{
  data && (
    <>
    
    {
       loader ? (
               <div className="spinner-border spinner-border-sm text-primary" role="status"></div>


        ) : ( 

          <>
               {/* <div className='me-2  d-flex align-items-center' >
                    <div className="f-light me-2">Verified Alerts</div>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={
                      <Popover>
                        <Popover.Header as="h3">Verified Alerts {data?.verifiedViolations + data?.verifiedNonViolations} </Popover.Header>
                        <Popover.Body> 
                          <ul>
                            <li className='mb-1'>
                                <b>Total Alerts</b>: {data?.totalAlerts}
                            </li> 
                            <li className='mb-1'>
                                <b>Verified Alerts</b>: {data?.verifiedViolations + data?.verifiedNonViolations}
                            </li>  
                            <li>
                                <b>Violations</b>: {data?.verifiedViolations}
                            </li>
                             <li>
                                <b>Non-Violations</b>: {data?.verifiedNonViolations}
                            </li>
                          </ul>
                        
                        </Popover.Body>
                      </Popover>
                    }
                  >
                     <Button variant="primary" className= "pop-hover-btn2"> {(data?.verifiedViolations + data?.verifiedNonViolations) }</Button>
                  </OverlayTrigger>
                  </div> */}

          </>


        )
    }
    

     </>
  )
}




   </>
  )
}
